module.exports = __webpack_public_path__ + "static/media/Classic Country Hollow Guitar Match off VR.17cd296.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Classic Country Hollow Guitar Match off VR.mp3
// module id = mty8
// module chunks = 12